import { useErrorNotifier } from "components/instrumentation/source";
import { useExperiments } from "components/store/source/context/ExperimentsContext";

import { ENABLE_DOTCOM_MAPBOX } from "types/experiments";

export const useEnableDotcomMapbox = (citySlug?: string) => {
  const { getExperiment } = useExperiments();
  const errorNotifier = useErrorNotifier();

  try {
    const experiment = getExperiment(ENABLE_DOTCOM_MAPBOX);
    if (!experiment || !citySlug) {
      return false;
    }

    return (
      experiment?.value === "on" &&
      experiment?.payload?.active_market_slugs?.includes(citySlug)
    );
  } catch (error) {
    errorNotifier.notify(
      error?.message ?? `Failed to get ${ENABLE_DOTCOM_MAPBOX} experiment`,
    );
    return false;
  }
};
